import { createTRPCUntypedClient, httpBatchLink } from "@trpc/client";

import { isTransportFailure } from "./offline-link";
import { NetworkUnavailableError, type OutboxSender } from "./offline-outbox";

/**
 * Chi porta al server quello che il dispositivo ha tenuto da parte.
 *
 * Usa un client tRPC suo, senza il link di coda: se lo attraversasse, un elemento che
 * fallisce tornerebbe in coda invece di contare il tentativo, e non uscirebbe mai.
 * Il formato sul filo resta identico a quello dell'invio diretto, perche e lo stesso link.
 */
const direct = createTRPCUntypedClient({
  links: [httpBatchLink({ url: "/api/trpc", maxItems: 3, maxURLLength: 1500 })],
});

function messageOf(error: unknown) {
  return error instanceof Error && error.message ? error.message : "Invio non riuscito.";
}

export const outboxSender: OutboxSender = {
  async sendTrpc(path, body) {
    try {
      return await direct.mutation(path, JSON.parse(body) as unknown);
    } catch (error) {
      // Mai arrivata al server: non e un tentativo fallito, e una rete che non c'e.
      if (isTransportFailure(error)) throw new NetworkUnavailableError();
      throw new Error(messageOf(error), { cause: error });
    }
  },

  async sendUpload(url, attachment) {
    const form = new FormData();
    form.set(
      attachment.field,
      new Blob([attachment.bytes], { type: attachment.mimeType }),
      attachment.filename,
    );
    let response: Response;
    try {
      response = await fetch(url, { method: "POST", body: form });
    } catch {
      throw new NetworkUnavailableError();
    }
    const payload = await response.json().catch(() => null) as { message?: string } | null;
    if (!response.ok) throw new Error(payload?.message ?? "Caricamento non riuscito.");
    return payload;
  },
};
